export default theme => {
    return {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/navigation/AdminButton.js